module.exports = __webpack_public_path__ + "img/book-title.151fbd26.png";